import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "actions" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "menu-header" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "d-flex align-center mb-4" }
const _hoisted_14 = { class: "px-4" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { class: "d-flex justify-center mt-4" }
const _hoisted_17 = { class: "d-flex justify-center my-4" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "menu-header" }
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "mb-2" }
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = { class: "d-flex align-center mb-4" }
const _hoisted_27 = { class: "px-4" }
const _hoisted_28 = { class: "d-flex" }
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = { class: "d-flex justify-center mt-4" }
const _hoisted_31 = { class: "d-flex justify-center my-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_hour_minute_input = _resolveComponent("hour-minute-input")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        variant: "flat",
        color: "primary",
        size: "large",
        onClick: _cache[0] || (_cache[0] = () => _ctx.isCreateDialogOpen = true),
        class: "create-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.create')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_table, { class: "mb-8" }, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.tableHeaders.name')), 1),
            _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.tableHeaders.abbreviation')), 1),
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.tableHeaders.color')), 1),
            _cache[13] || (_cache[13] = _createElementVNode("th", { class: "text-left" }, null, -1))
          ])
        ]),
        _createVNode(_component_draggable, {
          modelValue: _ctx.shiftPatterns,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shiftPatterns) = $event)),
          tag: "tbody",
          "item-key": "shiftPatternId",
          handle: ".drag-handle"
        }, {
          item: _withCtx(({ element: pattern }) => [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_v_icon, {
                  class: "drag-handle",
                  size: "small"
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode(" mdi-drag ", -1)
                  ]))]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(pattern.name), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString(pattern.abbreviation), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", {
                  class: "color-chip",
                  style: _normalizeStyle(`background-color: ${pattern.color};`)
                }, null, 4)
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "mx-2",
                      color: "primary",
                      variant: "outlined",
                      onClick: ($event: any) => (_ctx.setEditingPattern(pattern))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      class: "mx-2",
                      color: "red",
                      variant: "flat",
                      onClick: () => _ctx.deletingPattern = pattern
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      "max-width": "720px",
      modelValue: _ctx.isCreateDialogOpen,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isCreateDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.createTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  class: "mb-4",
                  "hide-details": "",
                  variant: "outlined",
                  label: _ctx.workSchedulingFormLabel('name'),
                  modelValue: _ctx.newPatternTitle,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPatternTitle) = $event)),
                  rules: [_ctx.required]
                }, null, 8, ["label", "modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  class: "mb-4",
                  "hide-details": "",
                  variant: "outlined",
                  label: _ctx.workSchedulingFormLabel('abbreviation'),
                  modelValue: _ctx.newPatternShorten,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPatternShorten) = $event)),
                  rules: [_ctx.required, _ctx.isAbbreviationValid]
                }, null, 8, ["label", "modelValue", "rules"]),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.color')), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_color_picker, {
                    modelValue: _ctx.newPatternColor,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newPatternColor) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.timeSlot')), 1),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newPatternTimeTables, (timetable, i) => {
                    return (_openBlock(), _createBlock(_component_v_card, {
                      key: i,
                      variant: "outlined",
                      class: "pa-4 my-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.category')), 1),
                        _createVNode(_component_v_select, {
                          class: "mb-4",
                          items: _ctx.descriptions,
                          "item-title": "title",
                          "item-value": "value",
                          variant: "outlined",
                          density: "compact",
                          "hide-details": "auto",
                          modelValue: timetable.category,
                          "onUpdate:modelValue": [($event: any) => ((timetable.category) = $event), ($event: any) => (_ctx.updateCategoryInCreate($event, i))],
                          color: "primary"
                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]),
                        (timetable.category === 'holiday')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t('workScheduling.holidayReason')), 1),
                              _createVNode(_component_v_text_field, {
                                class: "mb-4",
                                "hide-details": "auto",
                                density: "compact",
                                variant: "outlined",
                                modelValue: timetable.comment,
                                "onUpdate:modelValue": ($event: any) => ((timetable.comment) = $event),
                                color: "primary"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        (timetable.category === 'workDescription')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.workDescription')), 1),
                              _createVNode(_component_v_select, {
                                class: "mb-4",
                                items: _ctx.workDescriptionOptions,
                                "item-title": "title",
                                "item-value": "value",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                modelValue: timetable.workDescriptionId,
                                "onUpdate:modelValue": ($event: any) => ((timetable.workDescriptionId) = $event),
                                color: "primary"
                              }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.time')), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_hour_minute_input, {
                            modelValue: timetable.startMin,
                            "onUpdate:modelValue": ($event: any) => ((timetable.startMin) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.to')), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_hour_minute_input, {
                              modelValue: timetable.endMin,
                              "onUpdate:modelValue": ($event: any) => ((timetable.endMin) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_v_btn, {
                            variant: "flat",
                            color: "red",
                            onClick: ($event: any) => (_ctx.removeTimetable(i))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.deleteTimeSlot')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    color: "primary",
                    onClick: _ctx.createNewTimeTable
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.addTimeSlot')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "primary",
                  onClick: _ctx.createShiftPattern,
                  disabled: !_ctx.isNewPatternValid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            }),
            (_ctx.isCreatingNewPattern)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "720px",
      modelValue: _ctx.isEditDialogOpen,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isEditDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.editingPattern)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.editTitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      class: "mb-4",
                      "hide-details": "",
                      variant: "outlined",
                      label: _ctx.workSchedulingFormLabel('name'),
                      modelValue: _ctx.editingPattern.name,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingPattern.name) = $event))
                    }, null, 8, ["label", "modelValue"]),
                    _createVNode(_component_v_text_field, {
                      class: "mb-4",
                      "hide-details": "",
                      variant: "outlined",
                      label: _ctx.workSchedulingFormLabel('abbreviation'),
                      modelValue: _ctx.editingPattern.abbreviation,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingPattern.abbreviation) = $event))
                    }, null, 8, ["label", "modelValue"]),
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.color')), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_color_picker, {
                        modelValue: _ctx.editingPattern.color,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editingPattern.color) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.timeSlot')), 1),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingPattern.timetables, (timetable, i) => {
                        return (_openBlock(), _createBlock(_component_v_card, {
                          key: i,
                          variant: "outlined",
                          class: "pa-4 my-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.category')), 1),
                            _createVNode(_component_v_select, {
                              class: "mb-4",
                              items: _ctx.descriptions,
                              "item-title": "title",
                              "item-value": "value",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "auto",
                              modelValue: timetable.category,
                              "onUpdate:modelValue": [($event: any) => ((timetable.category) = $event), ($event: any) => (_ctx.updateCategoryInEdit($event, i))]
                            }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]),
                            (timetable.category === 'holiday')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t('workScheduling.holidayReason')), 1),
                                  _createVNode(_component_v_text_field, {
                                    class: "mb-4",
                                    "hide-details": "auto",
                                    density: "compact",
                                    variant: "outlined",
                                    modelValue: timetable.comment,
                                    "onUpdate:modelValue": ($event: any) => ((timetable.comment) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            (timetable.category === 'workDescription')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.workDescription')), 1),
                                  _createVNode(_component_v_select, {
                                    class: "mb-4",
                                    items: _ctx.workDescriptionOptions,
                                    "item-title": "title",
                                    "item-value": "value",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto",
                                    modelValue: timetable.workDescriptionId,
                                    "onUpdate:modelValue": [($event: any) => ((timetable.workDescriptionId) = $event), ($event: any) => (_ctx.selectWorkDescriptionInEdit($event, i))]
                                  }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.time')), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_hour_minute_input, {
                                modelValue: timetable.startMin,
                                "onUpdate:modelValue": ($event: any) => ((timetable.startMin) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.form.to')), 1),
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_hour_minute_input, {
                                  modelValue: timetable.endMin,
                                  "onUpdate:modelValue": ($event: any) => ((timetable.endMin) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]),
                            _createVNode(_component_v_text_field, {
                              class: "mb-4",
                              "hide-details": "",
                              variant: "outlined",
                              label: _ctx.workSchedulingFormLabel('name'),
                              modelValue: timetable.name,
                              "onUpdate:modelValue": ($event: any) => ((timetable.name) = $event),
                              rules: [_ctx.required]
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              class: "mb-4",
                              "hide-details": "",
                              variant: "outlined",
                              label: _ctx.workSchedulingFormLabel('abbreviation'),
                              modelValue: timetable.abbreviation,
                              "onUpdate:modelValue": ($event: any) => ((timetable.abbreviation) = $event),
                              rules: [_ctx.required, _ctx.isAbbreviationValid]
                            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "rules"]),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.color')), 1),
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_color_picker, {
                                modelValue: timetable.color,
                                "onUpdate:modelValue": ($event: any) => ((timetable.color) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_v_btn, {
                                variant: "flat",
                                color: "red",
                                onClick: ($event: any) => (_ctx.removeTimetableFromEditing(i))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.deleteTimeSlot')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_v_btn, {
                        variant: "flat",
                        color: "primary",
                        onClick: _ctx.insertTimetableToEditing
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.addTimeSlot')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.isUpdatingPattern)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary",
                      class: "my-2"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      onClick: _ctx.updateShiftPattern
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "720px",
      modelValue: _ctx.isDeleteDialogOpen,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isDeleteDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingPattern)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.shiftPatternSettings.deleteConfirm', { name: _ctx.deletingPattern.name })), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "grey",
                      class: "mx-2",
                      onClick: _cache[10] || (_cache[10] = () => _ctx.deletingPattern = null)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "red",
                      class: "mx-2",
                      onClick: _ctx.deletePattern
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isDeletingPattern)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}